import { render } from "./ViewFolder.vue?vue&type=template&id=031ae42e&scoped=true&lang=pug"
import script from "./ViewFolder.vue?vue&type=script&lang=js"
export * from "./ViewFolder.vue?vue&type=script&lang=js"

import "./ViewFolder.vue?vue&type=style&index=0&id=031ae42e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031ae42e"]])

export default __exports__